import { useState, useRef, useEffect } from 'react';

function useSearchCooldown(cooldownSeconds = 15) {
  const [cooldown, setCooldown] = useState(false);
  const [lastSearch, setLastSearch] = useState(null);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []); // reset on unmount

  const isNewSearch = (search) => !lastSearch || !(
    lastSearch.startDate === search.startDate &&
    lastSearch.endDate === search.endDate &&
    lastSearch.timezone === search.timezone
  );
  const searchOnCooldown = (search) => !isNewSearch(search) && cooldown;

  const startSearchCooldown = (search) => {
    setLastSearch(search);
    clearTimeout(timer.current);
    setCooldown(true);
    timer.current = setTimeout(() => {
      setCooldown(false);
    }, cooldownSeconds * 1000);
  };

  return {
    searchOnCooldown,
    startSearchCooldown,
  };
}

export default useSearchCooldown;
